module.exports = __webpack_public_path__ + "img/section5-item2.eb8488b6.png";